<template>
  <div class="seomain">
    <st-header
      :title="formData.id ? '编辑供应商' : '添加供应商'"
      :back-able="true"
    >
    </st-header>
    <div class="st-form-content">
      <st-form ref="form">
        <div class="st-form-title">基本信息</div>
        <div class="st-form-group">
					<van-cell-group inset>
						<st-form-item key="name" label="供应商名称" prop="name" :required="true">
							<van-field
								class="st-form-item-input"
								v-model="formData.name"
								name="供应商名称"
								label=""
								placeholder="请填写供应商名称"
							/>
						</st-form-item>
						
						<st-form-item key="code" label="供应商代码" prop="code">
							<van-field
								class="st-form-item-input"
								v-model="formData.code"
								name="供应商代码"
								label=""
								placeholder="请填写供应商代码"
							/>
						</st-form-item>
						
						<st-form-item key="category_id" label="供应商标签" prop="category_id">
						 <st-select
							 v-model="formData.category_id"
							 :def-text="formData.category_name"
							 name="供应商标签"
							 placeholder="请选择供应商标签"
							 :options="$option['getCategorys']"
							 :filterable="true"
							 :custom-params="{'type': 'supplier'}"
						 >
						 </st-select>
						</st-form-item>
						
						<st-form-item key="taxpayer_type" label="纳税人类型" prop="taxpayer_type" :required="true">
							<st-select
								 v-model="formData.taxpayer_type"
								 name="纳税人类型"
								 placeholder="请选择纳税人类型"
								 :options="$option['getModelConf']('supplier', 'taxpayerType')"
								 :filterable="false"
							>
							</st-select>
						</st-form-item>
						
						<st-form-item key="abbreviation" label="简称" prop="abbreviation" :required="true">
							<van-field
								class="st-form-item-input"
								v-model="formData.abbreviation"
								name="简称"
								label=""
								placeholder="请填写简称"
							/>
						</st-form-item>
						
						<st-form-item key="grade" label="等级" prop="grade">
							<van-field
								class="st-form-item-input"
								v-model="formData.grade"
								name="等级"
								label=""
								placeholder="请填写等级"
							/>
						</st-form-item>
          
            <st-form-item key="purchaser_id" label="采购员" prop="purchaser_id">
              <st-select
                v-model="formData.purchaser_id"
								:defText="formData.purchaser"
                name="采购员"
                placeholder="请选择采购员"
                :options="$option['getUserList']"
								:clearable="true"
              >
              </st-select>
            </st-form-item>
						
						<st-form-item key="settle_method" label="结算方式" prop="settle_method">
						 <st-select
							 v-model="formData.settle_method"
							 name="结算方式"
							 placeholder="请选择结算方式"
							 :options="$option['getModelConf']('supplier', 'settlemethod')"
							 :filterable="false"
						 >
						 </st-select>
						</st-form-item>
						
						<st-form-item key="url" label="官网地址" prop="url">
						  <van-field
						    class="st-form-item-input"
						    v-model="formData.url"
						    name="官网地址"
						    label=""
						    placeholder="请填写官网地址"
						  />
						</st-form-item>
						
						<st-form-item key="taxidentificationnumber" label="纳税识别号" prop="taxidentificationnumber">
						  <van-field
						    class="st-form-item-input"
						    v-model="formData.taxidentificationnumber"
						    name="纳税识别号"
						    label=""
						    placeholder="请填写纳税识别号"
						  />
						</st-form-item>
						
						<st-form-item key="developmentdate" label="开发日期" prop="developmentdate">
							<st-date
								v-model="formData.developmentdate"
								name="开发日期"
								placeholder="请选择开发日期"
								date-type="date"
							></st-date>
						</st-form-item>
											
						
						<st-form-item key="country_id" label="国家" prop="country_id" :required="true">
						  <van-field
						    class="st-form-item-input"
						    v-model="formData.country_id"
						    name="国家"
						    label=""
						    placeholder="请填写国家"
						  />
						</st-form-item>
						
					<st-form-item key="address" label="地址" prop="address">
					  <van-field
					    class="st-form-item-input"
					    v-model="formData.address"
					    name="地址"
					    label=""
							type="textarea"
					    placeholder="请填写地址"
					  />
					</st-form-item>
						
						
						<st-form-item key="data_files" label="营业执照" prop="data_files">
						  <st-file-upload
						    v-model="formData['data_files']"
						  >
						  </st-file-upload>
						</st-form-item>
						
						<st-form-item key="bank_files" label="银行资料" prop="bank_files" :required="true">
						  <st-file-upload
						    v-model="formData['bank_files']"
						  >
						  </st-file-upload>
						</st-form-item>
						
						<st-form-item key="asset_load_table_files" label="资产负载表（上年度+近三月）" prop="asset_load_table_files">
						  <st-file-upload
						    v-model="formData['asset_load_table_files']"
						  >
						  </st-file-upload>
						</st-form-item>
						
						<st-form-item key="income_statement_files" label="利润表（上年度+近三月" prop="income_statement_files">
						  <st-file-upload
						    v-model="formData['income_statement_files']"
						  >
						  </st-file-upload>
						</st-form-item>
						
						<st-form-item key="tax_return_files" label="纳税申报表（所得税：上年度+近季度（增值税：近三月）" prop="tax_return_files">
						  <st-file-upload
						    v-model="formData['tax_return_files']"
						  >
						  </st-file-upload>
						</st-form-item>
				
          </van-cell-group>
        </div>
        
				<div class="st-form-title">联系方式</div>
				<div class="st-form-group">
					<van-cell-group inset>
						<st-form-item key="contactone" label="联系人" prop="contactone" :required="true">
							<van-field
								class="st-form-item-input"
								v-model="formData.contactone"
								name="联系人"
								label=""
								placeholder="请填写联系人"
							/>
						</st-form-item>
						
						<st-form-item key="contactonenumber" label="联系电话" prop="contactonenumber" :required="true">
							<van-field
								class="st-form-item-input"
								v-model="formData.contactonenumber"
								name="联系电话"
								label=""
								placeholder="请填写联系电话"
							/>
						</st-form-item>
						
						<st-form-item key="wechat1" label="微信" prop="wechat1">
							<van-field
								class="st-form-item-input"
								v-model="formData.wechat1"
								name="微信"
								label=""
								placeholder="请填写微信"
							/>
						</st-form-item>
					
						<st-form-item key="qq1" label="QQ" prop="qq1">
							<van-field
								class="st-form-item-input"
								v-model="formData.qq1"
								name="QQ"
								label=""
								placeholder="请填写QQ"
							/>
						</st-form-item>
					
						<st-form-item key="email1" label="邮箱" prop="email1" :required="true">
							<van-field
								class="st-form-item-input"
								v-model="formData.email1"
								name="邮箱"
								label=""
								placeholder="请填写邮箱"
							/>
						</st-form-item>
					</van-cell-group>
				</div>
				
				<div class="st-form-title">银行信息</div>
				<div class="st-form-group">
					<van-cell-group inset>
						<st-form-item key="invoicetitle" :label="formData.taxpayer_type == 3? 'Company Name': '公司名称'" prop="invoicetitle">
							<van-field
								class="st-form-item-input"
								v-model="formData.invoicetitle"
								name="公司名称"
								label=""
							/>
						</st-form-item>
						
						<st-form-item key="taxnumber" label="纳税识别号" prop="taxnumber">
							<van-field
								class="st-form-item-input"
								v-model="formData.taxnumber"
								name="纳税识别号"
								label=""
							/>
						</st-form-item>
						
						<st-form-item key="invoicebank" :label="formData.taxpayer_type == 3? 'Bank Name': '开户银行'" prop="invoicebank">
							<van-field
								class="st-form-item-input"
								v-model="formData.invoicebank"
								name="开户银行"
								label=""
							/>
						</st-form-item>
						
						<st-form-item key="invoicebank_code" label="Bank Code" prop="invoicebank_code" v-if="formData.taxpayer_type == 3">
							<van-field
								class="st-form-item-input"
								v-model="formData.invoicebank_code"
								name="Bank Code"
								label=""
							/>
						</st-form-item>
						
						<st-form-item key="invoiceaccount_name" label="Account Name" prop="invoiceaccount_name" v-if="formData.taxpayer_type == 3">
							<van-field
								class="st-form-item-input"
								v-model="formData.invoiceaccount_name"
								name="Account Name"
								label=""
							/>
						</st-form-item>
						
						<st-form-item key="invoiceaccount" :label="formData.taxpayer_type == 3 ? 'Account NO': '银行账号'" prop="invoiceaccount">
							<van-field
								class="st-form-item-input"
								v-model="formData.invoiceaccount"
								name="银行账号"
								label=""
							/>
						</st-form-item>
						
						<st-form-item key="swiftcode" label="Swiftcode" prop="swiftcode" v-if="formData.taxpayer_type == 3">
							<van-field
								class="st-form-item-input"
								v-model="formData.swiftcode"
								name="Swiftcode"
								label=""
							/>
						</st-form-item>
					
						<st-form-item key="invoiceaddress" :label="formData.taxpayer_type == 3 ? 'Company Add': '注册地址'" prop="invoiceaddress" :required="true">
							<van-field
								class="st-form-item-input"
								v-model="formData.invoiceaddress"
								name="注册地址"
								label=""
							/>
						</st-form-item>
						
						<st-form-item key="invoicetel" :label="formData.taxpayer_type == 3 ? 'Tel': '联系方式'" prop="invoicetel" :required="true">
							<van-field
								class="st-form-item-input"
								v-model="formData.invoicetel"
								name="联系方式"
								label=""
							/>
						</st-form-item>
					</van-cell-group>
				</div>
				
				<div class="st-form-title">背景</div>
				<div class="st-form-group">
					 <van-cell-group inset>
						<st-form-item key="background" label="背景" prop="background" :required="true">
							 <st-select
								 v-model="formData.background"
								 name="背景"
								 placeholder="请选择背景"
								 :options="$option['getModelConf']('supplier', 'background')"
								 :filterable="false"
							 >
							 </st-select>
						</st-form-item>

						<div 
							class="reference-trade" 
							v-for="(v, k) in formData['reference_trade']"
							:key="k"
						>
							 <div class="trade-del-box" v-if="formData['reference_trade'].length > 1" @click="delTrade(k)"><i class="el-icon-close"></i></div>
							 <h3 style="text-align: center;">贸易参考{{ k + 1 }}</h3>
				 
							<st-form-item label="交易公司名" :prop="`reference_trade.${k}.company_name`">
							  <van-field
							    class="st-form-item-input readonly"
							    v-model="formData['reference_trade'][k]['company_name']"
							    name="交易公司名"
							    label=""
							    placeholder="请输入交易公司名"
							  />
							</st-form-item>
							
							<st-form-item label="公司地址" :prop="`reference_trade.${k}.company_add`">
							  <van-field
							    class="st-form-item-input"
							    v-model="formData['reference_trade'][k]['company_add']"
							    name="公司地址"
							    label=""
							    placeholder="请输入公司地址"
							  />
							</st-form-item>
							
							<st-form-item label="联系人" :prop="`reference_trade.${k}.contact`">
							  <van-field
							    class="st-form-item-input"
							    v-model="formData['reference_trade'][k]['contact']"
							    name="联系人"
							    label=""
							    placeholder="请输入联系人"
							  />
							</st-form-item>
							
							<st-form-item label="邮箱" :prop="`reference_trade.${k}.email`">
							  <van-field
							    class="st-form-item-input"
							    v-model="formData['reference_trade'][k]['email']"
							    name="邮箱"
							    label=""
							    placeholder="请输入邮箱"
							  />
							</st-form-item>
							
							<st-form-item label="电话" :prop="`reference_trade.${k}.phone`">
							  <van-field
							    class="st-form-item-input"
							    v-model="formData['reference_trade'][k]['phone']"
							    name="电话"
							    label=""
							    placeholder="请输入电话"
							  />
							</st-form-item>
							
							<st-form-item label="交易时长" :prop="`reference_trade.${k}.trans_long`">
							  <van-field
							    class="st-form-item-input"
							    v-model="formData['reference_trade'][k]['trans_long']"
							    name="交易时长"
							    label=""
							    placeholder="请输入交易时长"
							  />
							</st-form-item>
						 </div>
					     
					   <div style="margin: 16px;" class="new-pruduct-btn-box">
					     <button class="new-pruduct-btn" @click="newTrade">
					       <i class="el-icon-plus"></i>
					     </button>
					   </div>
					 </van-cell-group>
				</div>
				
				<div class="st-form-title">其他信息</div>
				<div class="st-form-group">
					<van-cell-group inset>
						<st-form-item key="averagearrivalperiod" label="平均到货期" prop="averagearrivalperiod">
							<van-field
								class="st-form-item-input"
								v-model="formData.averagearrivalperiod"
								name="平均到货期"
								label=""
								placeholder="请填写平均到货期"
							/>
						</st-form-item>
						
						<st-form-item key="deliveryperiod" label="货期" prop="deliveryperiod">
							<van-field
								class="st-form-item-input"
								v-model="formData.deliveryperiod"
								name="货期"
								label=""
								placeholder="请填写货期"
							/>
						</st-form-item>
						
						<st-form-item key="operatingproducts" label="经营产品" prop="operatingproducts">
							<van-field
								class="st-form-item-input"
								v-model="formData.operatingproducts"
								name="经营产品"
								label=""
								placeholder="请填写经营产品"
							/>
						</st-form-item>
					
						<st-form-item key="productcategory" label="产品类别" prop="productcategory">
							<van-field
								class="st-form-item-input"
								v-model="formData.productcategory"
								name="产品类别"
								label=""
								placeholder="请填写产品类别"
							/>
						</st-form-item>
					
						<st-form-item key="paycondition" label="付款条件" prop="paycondition" :required="true">
							<van-field
								class="st-form-item-input"
								v-model="formData.paycondition"
								name="付款条件"
								label=""
								placeholder="请填写付款条件"
								type="textarea"
							/>
						</st-form-item>
						
						<st-form-item key="remarks" label="备注" prop="remarks">
							<van-field
								class="st-form-item-input"
								v-model="formData.remarks"
								name="备注"
								label=""
								placeholder="请填写备注"
								type="textarea"
							/>
						</st-form-item>
					</van-cell-group>
				</div>
				
				
				
        <div style="margin: 16px;" class="form-submit-button">
          <van-button round block type="primary"  @click="onSubmit">
            提交
          </van-button>
        </div>
      </st-form>
    </div>
    
  </div>
</template>

<script>
import StFileUpload from "@/components/FileUpload.vue";
import StSelect from "@/components/Select.vue";
import StDate from "@/components/Date.vue";
import StHeader from "@/components/layout/Header.vue";
import StForm from "@/components/form.vue";
import StFormItem from "@/components/formItem.vue";

export default {
  components: {
    'st-file-upload': StFileUpload,
    'st-select': StSelect,
    "st-header": StHeader,
    "st-form-item": StFormItem,
		StForm,
		StDate
  },
  props: {},
  data() {
    return {
      formData: {
				data_files: [],
				bank_files: [],
				asset_load_table_files: [],
				income_statement_files: [],
				tax_return_files: [],
				reference_trade: [{}],
      }, 
      loading: false,
    };
  },
  watch: {},
	computed: {},
  created() {
    this.init();
    window.h5sdk && window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "添加采购订单" });
    });
  },
  mounted() {},

  methods: {
    init() {
			let query = this.$route.query;
			if (query.id) this.formData.id = query.id;
			this.getUpdateData();
		},
		// 获取编辑需要显示的数据
		getUpdateData() {
			if (this.formData.id) {
				this.$post(`${this.$api.supplierEditInfo}`, {id: this.formData.id}).then((res) => {
					let data = res.data;
					this.formData = data;
				}).catch((err) => {
					window.history.go(-1);
					console.log('supplier/edit', err);
				});
			} else {}
		},
		
		// 创建一个贸易参考
		newTrade() {
		  this.formData.reference_trade.push({});
		},
		
		// 删除一个产品
		delTrade(index) {
		  this.formData.reference_trade.splice(index, 1);
		},

    // 提交表单
    onSubmit() {
     this.$refs.form.validater.valid((isValid, lastError) => {
        if (!isValid) {
          this.$toast.fail('表单异常：' + lastError);
        }
      });
			
      let formData = JSON.parse(JSON.stringify(this.formData));
			formData['data_files'] = formData['data_files'].map((item) => { return item.url; }).join(',');
			formData['bank_files'] = formData['bank_files'].map((item) => { return item.url; }).join(',');
			formData['asset_load_table_files'] = formData['asset_load_table_files'].map((item) => { return item.url; }).join(',');
			formData['income_statement_files'] = formData['income_statement_files'].map((item) => { return item.url; }).join(',');
			formData['tax_return_files'] = formData['tax_return_files'].map((item) => { return item.url; }).join(',');
			if (this.formData.id) {
				this.updateData(formData);
			} else {
				this.addData(formData);
			}
      
    },
		
		addData(formData) {
			this.$post(this.$api.supplierAdd, formData).then((res) => {
			  if (res.code !== 1) {
			    this.$toast.fail(res.msg ? res.msg : '创建异常');
			  } else {
			    this.$toast.success("创建成功");
			    this.$router.replace(`/supplier/list`);
			  }
			});
		},
		updateData(formData) {
			this.$post(this.$api.supplierEdit, formData).then((res) => {
			  if (res.code !== 1) {
			    this.$toast.fail(res.msg ? res.msg : '编辑异常');
			  } else {
			    this.$toast.success("编辑成功");
			    this.$router.replace(`/supplier/list`);
			  }
			});
		},
  },
};
</script>

<style lang="scss" scoped>
.st-form-content {
  margin: 20px 15px;
	form {
		overflow: hidden;
	}
	
  .st-form-title {
    border-radius: 5px 5px 0px 0px;
    padding: 20px 21px;
    font-size: 20px;
    background-color: rgb(207, 212, 217);

    .st-van-btn-info {
      float: right;
    }
  }
  .st-form-group {
    background-color: white;
    margin-bottom: 20px;
    position: relative;
    overflow: hidden;
		padding-bottom: 16px;
		border-radius: 5px;
    
    .st-van-filed-label-imp {
      color: rgb(231, 91, 124);
    }

    .st-van-filed-label {
      margin: 15px 6px 8px; 
    }
    
    .van-field {
      box-shadow: inset 0 0 0 2px rgb(223,223,223);
      border-radius: 5px;
    }

    .form-submit-button {
      margin-top: 12px;
    }

		.data-size {
			display: flex;
			.span-x {
				line-height: 44px;
				padding: 0px 2px;
			}
		}
  }


	.reference-trade {
		background-color: rgba(230, 236, 241, 1);
		padding: 15px;
		margin-top: 18px;

		.trade-del-box {
			margin-top: -10px;
			float: right;
			text-align: right;
			font-size: 31px;
			color: rgba(227, 60, 100, 1);
		}
	}

	.new-pruduct-btn {
		width: 317px;
		height: 44px;
		border-radius: 5px;
		color: rgba(80, 80, 80, 1);
		background: rgba(42, 130, 228, 1);
		line-height: 150%;
		border: none;
		position: relative;
		left: 50%;
		transform: translateX(-50%);
		margin-top: 30px;

		.el-icon-plus {
			color: rgba(255, 255, 255, 1);
			font-size: 28px;
			font-weight: bolder;
		}
	}
}

</style>
